import React, { ReactNode } from 'react'
import { css } from '@emotion/core'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import Form from '@divvy-web/skylab.form'

const accessCodeValidations = {
  accessCode: {
    presence: {
      message: 'Please enter a valid access code',
    },
  },
}

interface AccessCodeFormProps {
  disableError: () => void
  children?: ReactNode
  handleSubmitAccessCode?: (accessCode: string) => void
}

const AccessCodeForm = ({ disableError, handleSubmitAccessCode, children }: AccessCodeFormProps) => {
  const [getClassName, makeTestId] = useNameFormatter('AccessCodeForm')
  return (
    <>
      <Form
        className={getClassName('')}
        css={accessCodeFormCss}
        dataTestId={makeTestId('')}
        validation={accessCodeValidations}
        onChange={() => disableError()}
        onSubmit={(_, { accessCode }) => handleSubmitAccessCode?.(accessCode as string)}
      >
        {children}
      </Form>
    </>
  )
}

const accessCodeFormCss = css`
  .field-container {
    max-width: 300px;
  }
`

export default AccessCodeForm
